import React from 'react';
import CommonTagsInputWrapper from './CommonTagsInputWrapper';
import GridColumnInputWrapper from './GridColumnInputWrapper';
import { personsActions } from '../../behavior/persons';
import CurrentRemoveUserTagButtonsWrapper from './CurrentRemoveUserTagButtonsWrapper';
import { UserDTO } from '@behavior/init/dto/UserDTO';

type Props = {
  userName: string;
  userLabel?: string;
  dteName?: string;
  dteLabel?: string;
  renderDefaultButtons?: boolean;
  setDefaultUser: (clear: boolean) => void;
  updateUserDateFieldsValidation: (val?: UserDTO) => void;
  showPersonalData?: any;
  columns?: number;
  errors?: any;
  userValue: any;
  dteValue: any;
  placeholder?: string;
};

const UserInput: React.FC<Props> = ({
  userName,
  userLabel,
  dteName,
  dteLabel,
  renderDefaultButtons,
  setDefaultUser,
  updateUserDateFieldsValidation,
  errors,
  userValue,
  dteValue,
  placeholder,
  ...props
}) => {
  return (
    <GridColumnInputWrapper
      {...props}
      name={userName}
      label={userLabel}
      errors={errors}
      specialRequiredCondition={dteValue != null}
      render={(props: any) => (
        <CommonTagsInputWrapper
          {...props}
          placeholder={placeholder}
          matchProperty="name"
          displayProps="name"
          value={userValue}
          maxTags={1}
          onlyUnique
          onSelect={updateUserDateFieldsValidation}
          className={
            renderDefaultButtons ? 'inputWithTwoInputDefaultButtons' : 'inputWidthStretched'
          }
          dynamicSuggestionListAction={personsActions.getPersonAutocompleteListAction}
          renderDefaultButtons={
            renderDefaultButtons ? (
              <CurrentRemoveUserTagButtonsWrapper setDefaultUser={setDefaultUser} {...props} />
            ) : null
          }
        />
      )}
    />
  );
};

export default UserInput;
